import type React from "react";

/** The delay between rows that mount together, and how many rows it runs across before it stops growing. */
const ROW_STAGGER_MS = 30;
const ROW_STAGGER_CAP = 8;

/**
 * The entrance for result row `index` (`tool-call-row-enter` in theme.css). Rows that stream in arrive one at
 * a time and enter at once; rows that mount together, when a finished card opens, cascade down the list.
 */
export function rowEntrance(index: number, isStreaming: boolean): { className: string; style?: React.CSSProperties } {
  if (isStreaming || index === 0) return { className: "tool-call-row-enter" };
  return {
    className: "tool-call-row-enter",
    style: { animationDelay: `${Math.min(index, ROW_STAGGER_CAP) * ROW_STAGGER_MS}ms` },
  };
}
